import { Page } from '@/core/architecture'

import { ResaleManagementTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ResaleManagement Page
 * Implemented as a practical sample.
 */
export const ResaleManagement: Page = () => {
  const { state, actions } = useViewModel()

  return <ResaleManagementTemplate state={state} {...actions} />
}
